import { render, staticRenderFns } from "./SerialAuthors.vue?vue&type=template&id=0b4de97d"
import script from "./SerialAuthors.vue?vue&type=script&lang=js"
export * from "./SerialAuthors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports